import './utils/dayjs';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './utils/imaLessonSwWarmup';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

if (process.env.NODE_ENV === 'development' && typeof window !== 'undefined') {
  import('./utils/lessonZipDebug').then((m) => {
    window.__IMA_LESSON_ZIP_DEBUG__ = {
      inspect: m.inspectLessonDoc,
      session: m.quickSessionCheck,
    };
    // eslint-disable-next-line no-console
    console.log('[IMA] __IMA_LESSON_ZIP_DEBUG__ sẵn sàng: .session() và .inspect(doc)');
  });
}
